module.exports = __webpack_public_path__ + "static/img/ewm.7108d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewm.png
// module id = 4+fO
// module chunks = 5